import CheckEmails from 'vcomponents/email/CheckEmails.vue';
import Feature from 'Services/Feature';
import EmailListing from 'vcomponents/email/listings/EmailListing.vue';
import ScheduledEmailListing from 'vcomponents/email/listings/ScheduledEmailListing.vue';
import SentEmailListing from 'vcomponents/email/listings/SentEmailListing.vue';
import OutboxEmailListing from 'vcomponents/email/listings/OutboxEmailListing.vue';
import ReceivedEmailListing from 'vcomponents/email/listings/ReceivedEmailListing.vue';
import EmailProvidersError from 'vcomponents/email/EmailProviderError.vue';

export default [
    {
        path: '/check-emails',
        name: 'checkemails',
        component: CheckEmails,
        beforeEnter(to, from, next) {
            if (!Feature.isEnabled('email-engine')) {
                next({ name: 'error.not.found' });
            } else {
                next();
            }
        },
    },
    {
        path: '/emails',
        name: 'emails',
        component: EmailListing,
        meta: {
            forceTitle: true,
        },
        beforeEnter: (to, from, next) => {
            if (Feature.isEnabled('email-engine')) {
                next();
            }
        },
        children: [
            {
                path: 'received',
                name: 'emails.received',
                component: ReceivedEmailListing,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'sent',
                name: 'emails.sent',
                component: SentEmailListing,
                meta: {
                    forceTitle: true,
                },
                beforeEnter(to, from, next) {
                    if (!Feature.isEnabled('email-engine-sent-emails')) {
                        next({ name: 'error.not.found' });
                    } else {
                        next();
                    }
                },
            },
            {
                path: 'scheduled',
                name: 'emails.scheduled',
                component: ScheduledEmailListing,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'outbox',
                name: 'emails.outbox',
                component: OutboxEmailListing,
                meta: {
                    forceTitle: true,
                },
                beforeEnter(to, from, next) {
                    if (!Feature.isEnabled('email-engine-outbox')) {
                        next({ name: 'error.not.found' });
                    } else {
                        next();
                    }
                },
            },
            {
                path: 'providers/error',
                name: 'emails.providers.error',
                component: EmailProvidersError,
            },
        ],
    },
];
